/*
  ============================================
  PC STORE COLOMBIA — THEME.JS
  Versión: 1.0.0
  ============================================
*/

/* ── SCROLL REVEAL ────────────────────────── */
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.1 });

document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

/* ── CART COUNT ───────────────────────────── */
function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

async function fetchCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    updateCartCount(cart.item_count);
  } catch(e) {}
}
fetchCartCount();

/* ── ADD TO CART ──────────────────────────── */
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-add-to-cart]');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  const qty = parseInt(btn.dataset.qty || 1);
  const originalText = btn.textContent;

  btn.disabled = true;
  btn.textContent = 'Agregando...';

  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    btn.textContent = '✓ Agregado!';
    btn.style.background = '#22c55e';
    btn.style.color = '#0f0f18';
    await fetchCartCount();
    setTimeout(() => {
      btn.textContent = originalText;
      btn.style.background = '';
      btn.style.color = '';
      btn.disabled = false;
    }, 2000);
  } catch(e) {
    btn.textContent = 'Error — intenta de nuevo';
    btn.disabled = false;
  }
});

/* ── PRODUCT GALLERY ──────────────────────── */
document.addEventListener('click', (e) => {
  const thumb = e.target.closest('.product-gallery__thumb');
  if (!thumb) return;

  const gallery = thumb.closest('.product-gallery');
  const mainImg = gallery?.querySelector('.product-gallery__main img');
  const src = thumb.querySelector('img')?.src;

  if (mainImg && src) {
    mainImg.style.opacity = '0';
    mainImg.style.transform = 'scale(.97)';
    setTimeout(() => {
      mainImg.src = src;
      mainImg.style.opacity = '1';
      mainImg.style.transform = 'scale(1)';
    }, 180);
  }

  gallery?.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('is-active'));
  thumb.classList.add('is-active');
});

/* ── QTY CONTROL ──────────────────────────── */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.qty-control__btn');
  if (!btn) return;

  const control = btn.closest('.qty-control');
  const valEl = control?.querySelector('.qty-control__value');
  if (!valEl) return;

  let val = parseInt(valEl.textContent) || 1;
  const dir = btn.dataset.dir === 'up' ? 1 : -1;
  val = Math.max(1, Math.min(10, val + dir));
  valEl.textContent = val;

  // Sync qty al botón de agregar al carrito
  const addBtn = document.querySelector('[data-add-to-cart]');
  if (addBtn) addBtn.dataset.qty = val;

  // Actualizar precio en el botón
  const basePrice = parseInt(addBtn?.dataset.basePrice || 0);
  if (basePrice) {
    const btnPriceEl = document.getElementById('btn-price-display');
    if (btnPriceEl) {
      btnPriceEl.textContent = (basePrice * val).toLocaleString('es-CO', {
        style: 'currency', currency: 'COP', minimumFractionDigits: 0
      });
    }
  }
});

/* ── WISHLIST TOGGLE ──────────────────────── */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-wishlist]');
  if (!btn) return;

  const icon = btn.querySelector('[data-wishlist-icon]');
  const isActive = btn.dataset.active === 'true';

  btn.dataset.active = (!isActive).toString();
  if (icon) icon.textContent = isActive ? '♡' : '♥';
  btn.style.color = isActive ? '' : '#e63030';
  btn.style.borderColor = isActive ? '' : 'rgba(230,48,48,.3)';
});

/* ── PRODUCT TABS ─────────────────────────── */
document.addEventListener('click', (e) => {
  const tab = e.target.closest('[data-tab]');
  if (!tab) return;

  const container = tab.closest('[data-tabs-container]');
  if (!container) return;

  const target = tab.dataset.tab;

  container.querySelectorAll('[data-tab]').forEach(t => t.classList.remove('is-active'));
  container.querySelectorAll('[data-tab-panel]').forEach(p => p.hidden = true);

  tab.classList.add('is-active');
  container.querySelector(`[data-tab-panel="${target}"]`)?.removeAttribute('hidden');
});

/* ── NAV SCROLL EFFECT ────────────────────── */
const nav = document.querySelector('.site-header');
let lastY = 0;
window.addEventListener('scroll', () => {
  const y = window.scrollY;
  if (nav) {
    nav.classList.toggle('is-scrolled', y > 60);
    nav.classList.toggle('is-hidden', y > lastY && y > 200);
  }
  lastY = y;
}, { passive: true });

/* ── BANNER CAROUSEL ──────────────────────── */
class BannerCarousel {
  constructor(el) {
    this.el = el;
    this.track = el.querySelector('[data-banner-track]');
    this.slides = el.querySelectorAll('[data-banner-slide]');
    this.dots = el.querySelectorAll('[data-banner-dot]');
    this.current = 0;
    this.total = this.slides.length;
    this.timer = null;

    el.querySelector('[data-banner-prev]')?.addEventListener('click', () => this.go(-1));
    el.querySelector('[data-banner-next]')?.addEventListener('click', () => this.go(1));
    this.dots.forEach((d, i) => d.addEventListener('click', () => this.goTo(i)));

    this.slides[0]?.classList.add('is-active');
    this.autoPlay();
  }

  goTo(n) {
    this.current = ((n % this.total) + this.total) % this.total;
    if (this.track) this.track.style.transform = `translateX(-${this.current * 100}%)`;
    this.dots.forEach((d, i) => d.classList.toggle('is-active', i === this.current));
    this.slides.forEach((s, i) => {
      if (i === this.current) {
        s.classList.remove('is-active');
        void s.offsetWidth; // force reflow para reiniciar la animación
        s.classList.add('is-active');
      } else {
        s.classList.remove('is-active');
      }
    });
  }

  go(dir) {
    this.goTo(this.current + dir);
    this.resetAuto();
  }

  autoPlay() {
    this.timer = setInterval(() => this.go(1), 5500);
  }

  resetAuto() {
    clearInterval(this.timer);
    this.autoPlay();
  }
}

document.querySelectorAll('[data-banner-carousel]').forEach(el => new BannerCarousel(el));
